import Color from '@base/features/game/model/color';

export default class Move {
  sourceLineNumber = 0;
  insertLineNumber = 0;
  _color?: Color;
  additionalMoves: Move[] = []; // move that was caused by this move, ex. move to bar when attack
  diceIndication?: number;
  byClick = false;
  started = false;

  getInsertLineNumber() {
    return this.insertLineNumber;
  }

  getSourceLineNumber() {
    return this.sourceLineNumber;
  }

  getDiceIndication() {
    return this.diceIndication;
  }

  getByClick() {
    return this.byClick;
  }

  setByClick(byClick: boolean) {
    this.byClick = byClick;
  }

  setDiceIndication(value: number) {
    this.diceIndication = value;
  }

  setInsertLineNumber(value: number) {
    this.insertLineNumber = value;
  }

  setSourceLineNumber(value: any) {
    this.sourceLineNumber = value;
  }

  set color(newColor: Color) {
    this._color = newColor;
  }

  get color() {
    if (this._color) return this._color;
    throw new Error('Color is not defined for a move');
  }

  addAdditionalMove(value: Move) {
    this.additionalMoves.push(value);
  }

  getAdditionalMoves() {
    return this.additionalMoves;
  }

  clearAdditionalMoves() {
    while (this.additionalMoves.length) {
      this.additionalMoves.pop();
    }
  }

  equat(another: Move) {
    return (
      this.sourceLineNumber === another.sourceLineNumber &&
      this.insertLineNumber === another.insertLineNumber &&
      this.color === another.color
    );
  }

  columnName(column: number) {
    if (column === 0 || column === 25) {
      return 'off';
    }
    if (column === 26 || column === 27) {
      return 'bar';
    }
    return column.toString();
  }

  toString() {
    //"%s%d/%d%s$%d"
    const offBar =
      this.getAdditionalMoves().length || this.sourceLineNumber === 26 || this.sourceLineNumber === 27;
    let result = this.color === Color.White ? 'W' : 'R';
    result += this.sourceLineNumber?.toString();
    result += '/';
    result += this.insertLineNumber;
    result += offBar ? '*' : '';
    result += '$';
    result += this.diceIndication;
    return result;
  }

  toHistory() {
    return this.columnName(this.sourceLineNumber!) + '/' + this.columnName(this.insertLineNumber!);
  }

  static fromString(str: string) {
    var res = /([RWrw])(\d+)\/(\d+)\*?\$(-?\d+)/.exec(str);
    if (!res) throw new Error('Неверная строка описания хода');

    var color = Color.fromString(res[1]);
    var from = parseInt(res[2]);
    var to = parseInt(res[3]);
    var dice = parseInt(res[4]);
    var offBar = false;

    if (str.indexOf('*') !== -1) {
      offBar = true; // offBar означает что либо это ход с бара, либо этот ход отправляет фишку на бар
    }
    var move = new Move();

    console.log('Move : offBar:  ' + offBar.toString());

    move.setInsertLineNumber(to);
    move.setSourceLineNumber(from);
    move.setDiceIndication(dice);
    move.color = color;

    // logic to calcualte additional moves
    var moveDirection = Math.sign(to - from);
    var forwardDirection = color === Color.Black ? 1 : -1;

    var isUndoMove;
    if (from === 26 || from === 27) {
      isUndoMove = false;
    } else if (to === 26 || to === 27) {
      isUndoMove = true;
    } else {
      isUndoMove = moveDirection === forwardDirection;
    }

    if (moveDirection === forwardDirection) {
      //do nothing - model will calcualte additional moves
    } else {
      //in that case, that is undo move, and we should add move from bar opponents checker
      if (isUndoMove && offBar) {
        var barNumber = color === Color.Black ? 27 : 26; //if that is black move, return white bar number
        var moveBackFromBar = new Move();
        moveBackFromBar.setSourceLineNumber(barNumber);
        moveBackFromBar.setInsertLineNumber(from);
        moveBackFromBar.color = Color.reverseColor(color);
        move.addAdditionalMove(moveBackFromBar);
      }
    }
    return move;
  }

  static reverseMove(move: Move) {
    var result = new Move();
    result.setSourceLineNumber(move.getInsertLineNumber());
    result.setInsertLineNumber(move.getSourceLineNumber());
    result.color = move.color;
    result.setDiceIndication(move.getDiceIndication()!);
    return result;
  }
}
